import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { IntroWelcomePage } from './intro-welcome';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";
import {CommonModule} from "@angular/common";

@NgModule({
  declarations: [
    IntroWelcomePage,
  ],
    imports: [
        IonicPageModule.forChild(IntroWelcomePage),
        PipesModule,
        DirectivesModule,
        CommonModule,

    ],
})
export class IntroWelcomePageModule {}



// WEBPACK FOOTER //
// ./src/pages/intro-welcome/intro-welcome.module.ts